export class UIAdController {
}
